export default {
  employer(state) {
    return state.employer
  },
  employerOriginal(state) {
    return state.employerOriginal
  },
  employers(state) {
    return state.employers
  },
  employersCounter(state) {
    return state.employersCounter
  },
  employerStatuses(state) {
    return state.employerStatuses
  },
  employerStates(state) {
    return state.employerStates
  },
  employerFilters(state) {
    return state.employerFilters
  },
  employerPermissions(state) {
    return state.employerPermissions
  },
  employerErrors(state) {
    return state.employerErrors
  },
  statuses(state) {
    return state.statuses
  },
  resources(state) {
    return state.resources
  },
  employerWorkPlaces(state) {
    return state.workPlaces
  },
  employersBrands(state) {
    return state.employersBrands
  },
  employerShedule(state) {
    return state.employerShedule
  },
  employerScheduleType(state) {
    return state.employerScheduleType
  },
  employerServices(state) {
    return state.employerServices
  },
  hrEmployers(state) {
    return state.hrEmployers
  },
  serviceEmployer(state) {
    return state.serviceEmployer
  },
  huntingResources(state) {
    return state.huntingResources
  },
  serviceEmployers(state) {
    return state.serviceEmployers
  },
  documentTypes(state) {
    return state.documentTypes
  },
  employerDocument(state) {
    return state.employerDocument
  },
  employerAvatar(state) {
    if (state.employer) {
      return state.employer.avatar
    }
    return ''
  },
}
